module.exports = __webpack_public_path__ + "media/components/country-flag/static/zm-e8fc2688a945effbd9a737f2e5cf6267.svg";